/* POWERCRAFT hero slide gauge (D30): reset progress gauge when active slide (aria-current) changes.
   Gauge duration = (section change_slides_speed - 0.6s) so the bar visibly fills and holds briefly before the slide advances.
   Also keeps autoplay running on hover/focus (user pref): Dawn pauses on mouseover/focusin; we neutralize pause() so it never stops (reduced-motion respected). */
(function(){
     function place(wrap, gauge){
            var a = wrap.querySelector('.slider-counter__link[aria-current="true"]') || wrap.querySelector('.slider-counter__link');
            if(!a){ return; }
            a.appendChild(gauge);
            gauge.classList.remove('run');
            void gauge.offsetWidth;
            gauge.classList.add('run');
     }
     function keepPlaying(){
            var hero = document.querySelector('[id$="__hero"] slideshow-component');
            if(!hero || typeof hero.pause !== 'function'){ return; }
            var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if(reduce){ return; }
            hero.pause = function(){};
            if(typeof hero.play === 'function'){ hero.play(); }
     }
     function init(){
            var hero = document.querySelector('[id$="__hero"] slideshow-component');
            var wrap = hero && hero.querySelector('.slideshow__control-wrapper');
            if(!wrap){ return; }
            var banner = hero.querySelector('.slideshow.banner');
            var speed = banner && parseFloat(banner.dataset.speed);
            if(!speed || isNaN(speed)){ speed = 5; }
            var gaugeSec = Math.max(2.5, speed - 0.6);
            hero.style.setProperty('--pc-hero-speed', gaugeSec + 's');
            var gauge = document.createElement('span');
            gauge.className = 'pc-hero-gauge';
            gauge.innerHTML = '<i></i>';
            place(wrap, gauge);
            var obs = new MutationObserver(function(){ place(wrap, gauge); });
            wrap.querySelectorAll('.slider-counter__link').forEach(function(b){ obs.observe(b, { attributes: true, attributeFilter: ['aria-current','class'] }); });
            if(window.customElements && customElements.whenDefined){ customElements.whenDefined('slideshow-component').then(keepPlaying); } else { keepPlaying(); }
     }
     if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
